export enum ExecutionStatus {
  IDLE = "IDLE",
  PASSED = "PASSED",
  FAILED = "FAILED",
  STOPPED = "STOPPED",
  RUNNING = "RUNNING",
  SKIPPED = "SKIPPED",
}

export interface StatusColorConfig {
  bgColor: string;
  textColor: string;
}

export interface StageResultDetail {
  actionTriggered: string;
  description: string;
}

export interface StageResult {
  stageId: string;
  stageName: string;
  status: ExecutionStatus;
  detail?: StageResultDetail;
}

export interface EvaluationStep {
  step_id: string;
  label: string;
  status: string;
  active: boolean;
  blocked: boolean;
  reason?: string;
}

export interface EvaluationBlock {
  block_label: string;
  steps: EvaluationStep[];
  status?: string;
  reason?: string;
}

export interface EvaluationApiResponse {
  needs_review: string;
  reason: string;
  config_loaded: boolean;
  matched_rule_label?: string;
  details: {
    blocks: EvaluationBlock[];
  };
}
